<template>
  <div class="fare-option-container box" style="min-width:300px;border: 1px solid #e3e2e2;">
    <h3 class="is-size-4 has-text-bold">{{ fareDescription }}</h3>
    <div class="is-size-5 has-text-grey">
      {{ solution.pricing.total | formatPriceFromDollars }}
    </div>
    <hr />

    <div v-for="(solutionService, solutionServiceIndex) in services" :key="solutionServiceIndex">
      <FareFamilyService :service="solutionService" />
    </div>
    <hr />

    <div v-if="solution.isSelectable &&
      solution.immediateTravelBookingAdvice != 'prevent'
      ">
      <div  class="is-inline-block is-clickable" style="width: 140px;">
        <b-button type="is-primary" expanded @click="checkSubmission(solution)">Book</b-button>
      </div>
      <span class="is-pulled-right"><OutOfPolicyTag position="is-left" :travelPolicy="solution.travelPolicy" /></span>
    </div>
    <div v-if="!solution.isSelectable" class="mt-4 is-size-7 has-text-grey is-block">
      Not selectable <span class="is-pulled-right"><OutOfPolicyTag position="is-left" :travelPolicy="solution.travelPolicy" /></span>
    </div>

    <div v-if="solution.isSelectable &&
      solution.immediateTravelBookingAdvice == 'prevent'
      " class="mt-4 notification is-size-7 has-text-grey has-text-centered">
      To book this option call: <br />
      877-924-0303 <div><OutOfPolicyTag position="is-left" :travelPolicy="solution.travelPolicy" class="pt-2"/></div>
    </div>

  </div>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin";
import FareFamilyService from "./FareFamilyService.vue";
import AddMeetingGuest from "../../Meetings/AddMeetingGuest.vue";
import OutOfPolicyTag from "../../Tags/OutOfPolicyTag.vue";
import meetingsMixin from "@/mixins/meetingsMixin";

export default {
  name: "FareOption",
  mixins: [bookingMixin, meetingsMixin],
  props: {
    solution: Object,
  },
  components: {
    FareFamilyService, OutOfPolicyTag,
  },
  data: function () {
    return {
      multiline: true,
    };
  },
  computed: {
    fareFamily() {
      return this.solution.fareFamily;
    },
    fareDescription() {
      return this.fareFamily?.familyDescription;
    },
    services() {
      return this.fareFamily?.services;
    },
  },
  methods: {
    checkSubmission(sol) {
      // console.log('checkSubmission', sol);

      if (sol.immediateTravelBookingAdvice == "warn") {
        this.$buefy.dialog.confirm({
          message:
            "You have selected a flight with a departure time in the next few hours. Please watch your email for your Final Ticketed Itinerary.  If you do not receive your Final Ticketed Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.   ",
          confirmText: "Continue booking",
          type: "is-info",
          hasIcon: true,
          onConfirm: () => this.submitted(sol),
        });
      } else {
        this.submitted(sol);
      }
    },
    submitted(value) {
      //hide the Fare Options modal
      this.$store.commit("bookTravel/HIDE_FARE_OPTIONS");

      this.$store.dispatch("bookTravel/alterResult", value);

      if (this.pathMixin_isMeeting) {
        this.meetingRouter();

        if (this.meetingInfo.allowedToBringGuest) {
          this.$buefy.modal.open({
            parent: this,
            component: AddMeetingGuest,
            props: {},
            hasModalCard: true,
            trapFocus: true,
            width: 650,
          });
        }
      } else {
        this.$nav.pushRouteTo({ name: "BookingItinerary" });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
